export { default as SimpleHomePage } from './simple-home-page';
export * from './types';
